import { render, staticRenderFns } from "./maskBg.vue?vue&type=template&id=0c251408&scoped=true&"
import script from "./maskBg.vue?vue&type=script&lang=js&"
export * from "./maskBg.vue?vue&type=script&lang=js&"
import style0 from "./maskBg.vue?vue&type=style&index=0&id=0c251408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c251408",
  null
  
)

export default component.exports